import { z } from 'zod'
import { UserRole } from '../../enums/user-role.enum'

// base shape without defaults or refinements; update schema calls .partial() on this
// so that omitted fields stay undefined and don't overwrite existing scope/value in the DB
export const featureFlagBaseSchema = z.object({
  name: z
    .string()
    .min(2, 'name must be at least 2 characters')
    .max(100)
    .regex(/^[a-z0-9_-]+$/, 'name must be lowercase alphanumeric with hyphens or underscores'),
  description: z.string().max(500).optional(),
  value: z.string().max(5000).optional(),
  enabled: z.boolean().optional(),
  targetRoles: z.array(z.nativeEnum(UserRole)).optional(),
  targetUserIds: z.array(z.string().guid()).optional(),
})

export const singleScopeRefinement = (d: { targetRoles?: unknown[]; targetUserIds?: unknown[] }) =>
  !((d.targetRoles?.length ?? 0) > 0 && (d.targetUserIds?.length ?? 0) > 0)

export const singleScopeError = {
  message:
    'a flag row must claim exactly one scope: all-users, a role, or a user — not both role and user',
  path: ['targetRoles'] as PropertyKey[],
}

export const createFeatureFlagSchema = featureFlagBaseSchema
  .extend({
    value: z.string().max(5000).optional().default(''),
    enabled: z.boolean().optional().default(false),
    targetRoles: z.array(z.nativeEnum(UserRole)).optional().default([]),
    targetUserIds: z.array(z.string().guid()).optional().default([]),
  })
  .refine(singleScopeRefinement, singleScopeError)
export type CreateFeatureFlagDto = z.infer<typeof createFeatureFlagSchema>
